import React, { useState } from 'react';
import { Input, Select, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import s from './index.module.css';

const { Option } = Select;

const SearchBox = ({ onSearch }) => {
  const searchTypes = [
    { value: 'institution', label: '找机构' },
    { value: 'expert', label: '找专家' },
    { value: 'knowledge', label: '找知识' }
  ];

  const [searchType, setSearchType] = useState('institution');
  const [searchValue, setSearchValue] = useState('');

  const handleSearchClick = () => {
    if (onSearch) {
      onSearch({ keyword: searchValue, type: searchType });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchClick();
    }
  };

  return (
    <div className={s.searchBox}>
      <div className={s.searchBar}>
        <Select
          value={searchType}
          className={s.searchDropdown}
          dropdownClassName={s.searchDropdownPopup}
          onChange={setSearchType}
          bordered={false}
        >
          {searchTypes.map(type => (
            <Option key={type.value} value={type.value}>
              {type.label}
            </Option>
          ))}
        </Select>

        <Input
          className={s.searchInput}
          placeholder="请输入搜索关键词"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyPress={handleKeyPress}
          bordered={false}
        />

        <Button
          type="primary"
          icon={<SearchOutlined />}
          className={s.searchButton}
          onClick={handleSearchClick}
        />
      </div>
    </div>
  );
};

export default SearchBox;
